import React, { useState, useEffect } from 'react';
import Research from '../Research';
import useResearch from '../../../_shared/hooks/trade/useResearch';
import { VdpMarketGuidePath } from '../../../_shared/constants/vdp';

const ResearchContainer = ({ tradeDetails, tradeState, isOMP }) => {
  const [researchUrl, setResearchUrl] = useState('');

  const { researchPrices, isLoaded } = useResearch(isOMP, tradeDetails);

  useEffect(() => {
    if (isLoaded) {
      if (isOMP) {
        const {
          decodedYear,
          decodedMake,
          decodedModel,
          decodedTrim
        } = researchPrices;
        const parameters = new URLSearchParams();
        if (decodedYear) {
          parameters.append('year', decodedYear);
        }
        if (decodedMake) {
          parameters.append('make', decodedMake);
        }
        if (decodedModel) {
          parameters.append('model', decodedModel);
        }
        if (decodedTrim) {
          parameters.append('trim', decodedTrim);
        }
        setResearchUrl(VdpMarketGuidePath.concat(parameters.toString()));
      } else {
        setResearchUrl(`/research?vin=${tradeDetails?.vin}`);
      }
    }
  }, [isOMP, researchPrices, tradeDetails?.vin, isLoaded]);

  return (
    <Research
      researchUrl={researchUrl}
      researchPrices={researchPrices}
      vin={tradeDetails?.vin}
      tradeState={tradeState}
      isResearchDataLoaded={isLoaded}
    />
  );
};

export default ResearchContainer;
